'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailHelpText = ({
  shouldRenderExternalEmailWarningMsg
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-action-components.actions.emailReport.dialog.footer.helpText_jsx",
        options: {
          allowlistUrl: 'https://knowledge.hubspot.com/articles/KCS_Article/Email/What-steps-can-I-take-to-ensure-HubSpot-emails-get-delivered-to-my-inbox',
          notificationUrl: 'https://knowledge.hubspot.com/articles/kcs_article/settings/how-to-set-up-user-notifications-in-hubspot'
        },
        elements: {
          Link1: Link,
          Link2: Link
        }
      })
    })
  }), shouldRenderExternalEmailWarningMsg && /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.emailReport.dialog.footer.externalEmailPIINote"
      })
    })
  })]
});
export default EmailHelpText;